module.exports = __webpack_public_path__ + "static/media/properPackaging.94a70325.png";